import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Columns = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke || 'currentColor'}
      {...props}
    >
      <path d="M8 2.5H11.5C12.6046 2.5 13.5 3.39543 13.5 4.5V11.5C13.5 12.6046 12.6046 13.5 11.5 13.5H8M8 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V11.5C2.5 12.6046 3.39543 13.5 4.5 13.5H8M8 2.5V13.5" />
    </svg>
  ),
)
Columns.displayName = 'Columns'

export default Columns
